import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations, LANGUAGES } from "@/lib/i18n";

const LanguageContext = createContext(null);

const getInitialLanguage = () => {
  try {
    const stored = window.localStorage.getItem("dr-lang");
    if (stored && translations[stored]) return stored;
  } catch (e) {
    if (process.env.NODE_ENV === "development") console.warn("Failed to read stored language preference:", e);
  }
  return "es";
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback((code) => {
    if (!translations[code]) return;
    setLanguageState(code);
    try {
      window.localStorage.setItem("dr-lang", code);
    } catch (e) {
      if (process.env.NODE_ENV === "development") console.warn("Failed to persist language preference:", e);
    }
  }, []);

  const value = useMemo(
    () => ({ language, setLanguage, t: translations[language], languages: LANGUAGES }),
    [language, setLanguage]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
